import React from "react";
import withProviders from "../../../hooks/withProviders";
import { GenericLayoutPageSubHeader, Main } from "../../../components/utilities";
import { MicroserviceManagementProvider, MicroserviceActionsDropdown, MicroserviceStatusDisplay, MicroserviceActionsDropdownItem } from "../../../features/microservicemanagement";
import { oidcClient } from "../../../redux/token";
import toast from "react-hot-toast";
import { MicroserviceEventsTable } from "../../../features/microserviceeventstable";
import { useLazyFetchReviewMicroserviceEventsQuery } from "../../../services/clientreviews";

export const ClientReviewsMicroserviceManagementPage = withProviders([
    MicroserviceManagementProvider, {
        healthEndpoint: '/api/review/health',
        seedEndpoint: '/api/review/system/seed'
    }
])(({
    scheduleReviewsEndpoint = "/api/review/review/schedule",
    activateReviewsEndpoint = "/api/review/review/activate",
    completeReviewsEndpoint = "/api/review/review/complete",
    scoreReviewsEndpoint = "/api/review/review/scorecompleted",
}: Readonly<{
    scheduleReviewsEndpoint?: string,
    activateReviewsEndpoint?: string,
    completeReviewsEndpoint?: string,
    scoreReviewsEndpoint?: string,
}>) => {

    const executeScheduleReviewsJob = () => {
        let tokenData = oidcClient.getOidcToken();
        fetch(scheduleReviewsEndpoint, {
            method: 'POST',
            headers: {
                'Authorization': `${tokenData?.token_type} ${tokenData?.access_token}`,
                'Content-Type': 'application/json'
            },
            body: ""
        })
            .then(() => toast('Schedule Reviews Job has started.'))
            .catch(() => toast.error('Failed to start the Schedule Reviews Job.'));
    };

    const executeActivateReviewsJob = () => {
        let tokenData = oidcClient.getOidcToken();
        fetch(activateReviewsEndpoint, {
            method: 'POST',
            headers: {
                'Authorization': `${tokenData?.token_type} ${tokenData?.access_token}`,
                'Content-Type': 'application/json'
            },
            body: ""
        })
            .then(() => toast('Activate Reviews Job has started.'))
            .catch(() => toast.error('Failed to start the Activate Reviews Job.'));
    };

    const executeCompleteReviewsJob = () => {
        let tokenData = oidcClient.getOidcToken();
        fetch(completeReviewsEndpoint, {
            method: 'POST',
            headers: {
                'Authorization': `${tokenData?.token_type} ${tokenData?.access_token}`,
                'Content-Type': 'application/json'
            },
            body: ""
        })
            .then(() => toast('Complete Reviews Job has started.'))
            .catch(() => toast.error('Failed to start the Complete Reviews Job.'));
    };

    const executeScoreCompletedReviewsJob = () => {
        let tokenData = oidcClient.getOidcToken();
        fetch(scoreReviewsEndpoint, {
            method: 'POST',
            headers: {
                'Authorization': `${tokenData?.token_type} ${tokenData?.access_token}`,
                'Content-Type': 'application/json'
            },
            body: ""
        })
            .then(() => toast('Score Reviews Job has started.'))
            .catch(() => toast.error('Failed to start the Score Reviews Job.'));
    };

    return (<Main className="d-flex flex-column">
        <GenericLayoutPageSubHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <MicroserviceStatusDisplay />
                </div>
                <div className="d-flex flex-fill justify-content-end align-items-center">
                    <MicroserviceActionsDropdown>
                        <MicroserviceActionsDropdownItem icon={['fas', 'clock']} onClick={executeScheduleReviewsJob} text="Schedule Reviews" />
                        <MicroserviceActionsDropdownItem icon={['fas', 'play']} onClick={executeActivateReviewsJob} text="Activate Reviews" />
                        <MicroserviceActionsDropdownItem icon={['fas', 'check']} onClick={executeCompleteReviewsJob} text="Complete Reviews" />
                        <MicroserviceActionsDropdownItem icon={['fas', 'trophy']} onClick={executeScoreCompletedReviewsJob} text="Score Reviews" />
                    </MicroserviceActionsDropdown>
                </div>
            </div>
        </GenericLayoutPageSubHeader>
        <section className="px-4 my-3 h-100">
            <MicroserviceEventsTable query={useLazyFetchReviewMicroserviceEventsQuery} />
        </section>
    </Main>
    )
});